import React, { useEffect, useState } from 'react';
import api from '../services/api';
import ReportPrintLayout from '../components/ReportPrintLayout';

const ReportsClientsPrint = () => {
  const [clients, setClients] = useState([]);

  const fetchClients = async () => {
    try {
      const res = await api.get('/clients');
      setClients(Array.isArray(res.data) ? res.data : []);
    } catch (e) {
      setClients([]);
    }
  };

  useEffect(() => {
    fetchClients();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Prepare data for the print layout
  const printData = clients.length > 0 ? {
    summary: {
      total_items: clients.length,
      inventory_value: 0,
      low_stock_count: 0,
      out_of_stock_count: 0,
      best_selling_count: 0,
      slow_moving_count: 0,
      adjustments_count: 0,
    },
    // For client report, we'll use a custom structure
    clients: clients,
  } : null;

  return (
    <ReportPrintLayout
      reportData={printData}
      dateRange={{ start: new Date().toISOString().slice(0, 10), end: new Date().toISOString().slice(0, 10) }}
      reportType="clients"
    />
  );
};

export default ReportsClientsPrint;